<div class="mat-card mat-elevation-z2 p-24">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h1 pr-16">{{ data.nombre }}</div>
    </div>

    <mat-list>
        <mat-list-item>
            <h3 matLine>Cliente</h3>
            <p matLine>
                <span class="secondary-text">{{ data.nombre }} - </span>
                <span class="text-bold">{{ data.rut }}</span>
                <button
                    mat-icon-button
                    type="button"
                    color="accent"
                    (click)="editar(data)"
                >
                    <mat-icon>edit</mat-icon>
                </button>
            </p>
        </mat-list-item>

        <mat-list-item *ngIf="data.fechaTermino == null">
            <h3 matLine>Habilitado desde</h3>
            <p matLine>
                <span class="secondary-text">{{
                    data.fechaInicio | date: "dd-MM-yyyy HH:mm:ss"
                }}</span>
            </p>
        </mat-list-item>

        <mat-list-item>
            <p matLine>
                Estado:
                <mat-slide-toggle
                    #checkActivacion
                    (change)="toggleEstadoCliente(data)"
                    >{{
                        data.fechaTermino == null ? "Activado" : "Desactivado"
                    }}</mat-slide-toggle
                >
            </p>
        </mat-list-item>
    </mat-list>
</div>
